/** Intl message ids for section titles (cards and inner drawer). */
export const processPortalSectionTitleIdByConfigId = {
  'config-process': 'global.text.processes',
  'config-report': 'global.text.reports',
  'config-app': 'processPortal.menu.apps',
  'config-list': 'global.text.lists',
  'config-entity': 'global.text.entities',
  'config-permission': 'global.text.permissions',
  'config-menu': 'global.text.menu',
};

export const ConfigProcess = {
  id: 'config-process',
  title: processPortalSectionTitleIdByConfigId['config-process'],
  description: 'processPortal.descriptionProcess',
};

export const ConfigReport = {
  id: 'config-report',
  title: processPortalSectionTitleIdByConfigId['config-report'],
  description: 'processPortal.descriptionReport',
};

export const ConfigApp = {
  id: 'config-app',
  title: processPortalSectionTitleIdByConfigId['config-app'],
  description: 'processPortal.descriptionApp',
};

export const ConfigPermission = {
  id: 'config-permission',
  title: processPortalSectionTitleIdByConfigId['config-permission'],
  description: 'processPortal.descriptionPermission',
};

export const ConfigList = {
  id: 'config-list',
  title: processPortalSectionTitleIdByConfigId['config-list'],
  description: 'processPortal.descriptionList',
};

export const ConfigEntity = {
  id: 'config-entity',
  title: processPortalSectionTitleIdByConfigId['config-entity'],
  description: 'processPortal.descriptionEntity',
};

export const ConfigMenu = {
  id: 'config-menu',
  title: processPortalSectionTitleIdByConfigId['config-menu'],
  description: 'processPortal.descriptionMenu',
};

export default [
  {
    ...ConfigProcess,
  },
  {
    ...ConfigReport,
  },
  {
    ...ConfigApp,
  },
  {
    ...ConfigList,
  },
  {
    ...ConfigEntity,
  },
  {
    ...ConfigPermission,
  },
  {
    ...ConfigMenu,
  },
];
